export { default as Article } from "./components/Main";
export { default as ArticlePreview } from "./components/Preview";
export type { ArticleProps } from "./components/Main";
